import { Box, Typography } from "@mui/material";
import React from "react";

interface ModeHeaderProps {
  label: string;
  description: string;
}

export default function ModeHeader({ label, description }: ModeHeaderProps) {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold">
        {label}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Box>
  );
}
